export default __webpack_public_path__ + "static/media/4.ce1b88b8.jpg";